"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Minus = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Minus = function () { return (react_1.default.createElement("rect", { width: "1.945", height: "18", x: "21", y: "11", fill: "currentColor", rx: "0.972", transform: "rotate(90 21 11)" })); };
exports.Minus = Minus;
//# sourceMappingURL=minus.js.map